import React from 'react';
import { createRoot } from 'react-dom/client';
import StepProgressButton from '../components/StepProgressButton';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('step-progress-button-app');

  if (!node) {
    return;
  }

  const props = {
    dir: node.dataset.dir,
    endpoint: node.dataset.endpoint,
    text: node.dataset.text,
  };

  createRoot(node).render(<StepProgressButton {...props} />);
});
